import type { ActivityItem, AppNotification, Invitation, Presence, PublicConfig } from "../../domain/app-types.ts";

export class CollaborationRuntimeState {
  notifications: AppNotification[] = [];
  invitations: Invitation[] = [];
  presence: Presence[] = [];
  activity = new Map<string, ActivityItem[]>();
  browserNotified = new Set<string>();
  delivery = { email: false, webPush: false };

  applyPublicConfig(config: PublicConfig | null | undefined): void {
    this.delivery = {
      email: !!config?.notification_email_available,
      webPush: !!config?.notification_web_push_available,
    };
  }

  unreadNotificationCount(): number {
    return this.notifications.filter(item => !item.read).length;
  }
}
